<template>
  <section class="footer-nav">
    <FooterBorderLines />
    <div class="footer-nav-wrapper bg-primary">
      <div class="container">
        <div class="row">
          <div v-for="column in footerNav" :key="column.id" class="col-12 col-sm-4 col-md-3">
            <p class="h5">{{ column.title }}</p>
            <ul>
              <li v-for="item in column.children">
                <Link :href="item.link">{{ item.title }}</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import FooterBorderLines from "@/components/footer/FooterBorderLines";
import Link from "@/components/common/Link";
export default {
  components: {Link, FooterBorderLines},
  props: {
    footerNav: Array
  }
}
</script>
